import { Event } from 'dataSources/Typicode/events/types';
import { TIsLoading } from 'common/types/common';
import { TStationCode } from 'dataSources/Typicode/stations/types';

export const STATE = 'SPECIAL_EVENTS';
export interface IState {
  specialEvents: {
    isLoading: TIsLoading;
    data: Event[];
    scrollToSelectedEvent: string;
  };
  activeSpecialEvent: {
    isLoading: TIsLoading;
    onlyForAuthorizedUsers: boolean;
    data: {
      title: string;
      stationInternalIds: TStationCode[];
    } | null;
  };
}
